<template>
  <div class="popular-container">
    <h4 class="popular-title">Our most popular offers</h4>

    <div class="four-cards-group">
      <b-card-group deck class="deck-cards">
        <b-card
          v-for="(product) in activeCards()"
          :key="product.id"
          :title="product.cardTitle"
          :img-src="product.cardImage"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius"
          id="productCard"
          ref="btnFreeShow"
          @click="updateQueryParams(product.category, product.id); idContent(product); showModalOrOpenLink(product.hasModal, product.cardUrl);"
        >
          <b-card-text>
            {{ product.cardDescription }}
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>

    <!-- MODAL GENERIC -->
    <FreeModalComponent :id="id" :freeCardsData="freeCardsData" :customerInfo="customerInfo"/>


    <!-- BUTTON -->
    <div class="button-see-more-box" v-if="!hiddenButton">
      <b-button
        pill
        variant="outline-dark"
        class="button-see-more"
        @click="loadMore"
        >See More</b-button
      >
    </div>
  </div>
</template>

<script>
import FreeModalComponent from '@/components/centre/perks/free/FreeModalComponent.vue';


export default {
  name: "FreePerksShowAllCards",
  components: {
    FreeModalComponent,
  },
  props: ["customerInfo", "freeCardsData", "id"],
  mounted() {
    if (this.$route.name === 'Free' && this.$route.query.category) {
      this.activeCategory = this.$route.query.category;
    } else {
      this.activeCategory = 'ShowAll';
    }
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  updated() {
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  data() {
    return {
      activeCategory: 'ShowAll',
      length: 20,
      hiddenButton: false,
    };
  },
  computed: {

  },
  methods: {
    showModalOrOpenLink(hasModal, url) {
      if(hasModal) {
        this.$root.$emit('bv::show::modal', 'free-modal', '#btnFreeShow');
      } else {
        if(url !== '') {
          //to open an external link instead of a modal
        window.open(url, '_blank', 'noreferrer');
        }
      }
    },
    activeCards: function() {
      this.$root.$on("free-category", (value) => {
        this.activeCategory = value;
        //to restart initial lenght in case the button show more was clicked
        this.length = 20;
      });
      if (this.activeCategory !== 'ShowAll') {
        return this.freeCardsData.filter((u) => {
          return u.category === this.activeCategory;
        }).slice(0, this.length);
      }
      return this.freeCardsData.slice(0, this.length);
    },
    loadMore() {
      if (this.length > this.freeCardsData.length) return;
      this.length = this.length + 4;
    },
    updateQueryParams(category, id) {
      //UPDATING QUERY PARAM
      this.$router.push({
        name: "Perks",
        query: { category: category, id: id },
      }).catch(()=>{});
    },
    idContent(idContent) {
      this.$root.$emit(
        "free-content",
        idContent
      );
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.popular-title {
  font-weight: 700;
  margin: 3rem 0;
}

.deck-cards {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}

div.card {
  border: none;
  //display: inline-block;
  cursor: pointer;
}

.card-img-top {
  //background-color: $light-gray;
  //margin-bottom: 2rem;
}

h4.card-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.add-border-radius {
  border-radius: 1rem;
  //margin-left: 0;
  //margin-right: 0;
  min-width: 209.5px;
  max-width: 209.5px;
  margin: 1rem 1.25rem;

  //object-fit: cover;

  img {
    border-radius: 1rem 1rem 0 0;
    background-color: $light-gray;
    height: 220px;
  }
}

.button-see-more-box {
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  button {
    font-weight: 700;
    &:hover {
      background-color: black;
    }
  }
}

/* Row Container */
.row {
  display: flex;
  flex-wrap: wrap;
}

/* In order to create four equal columns */
.column {
  flex: 25%;
  padding: 20px;
}

/* two columns */
@media screen and (max-width: 992px) {
  .column {
    flex: 50%;
  }

  .deck-cards.card-deck {
    justify-content: center;
  }
}

/* One column */
@media screen and (max-width: 600px) {
  .row {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .card-deck {
    margin-left: 0;
  }
}

@media screen and (max-width: 575px) {
  .four-cards-group {
    margin-bottom: 0;
  }

  .card-deck {
    display: block;
    text-align: -webkit-center;
  }

  .add-border-radius {
    margin-right: 1rem;
  }
}

@media screen and (max-width: 399px) {
  .card-deck {
    text-align: -webkit-center;
  }
}
</style>
